import HTTP from "@/packages/http";
import * as EP from "./endpoints.js";

export default {
  login(data) {
    return HTTP.post(EP.LOGIN, { ...data }).then(({ data }) => data);
  },
  forgotPassword(data) {
    return HTTP.post(EP.FORGOT_PASSWORD, { ...data }).then(({ data }) => data);
  },
  shopifyInstallApp(data) {
    return HTTP.get(EP.SHOPIFY_INSTALL_APP, { params: data }).then(({ data }) => data);
  },
  checkRegistrationPage(data) {
    return HTTP.get(EP.CHECK_REGISTER_PAGE + "?" + data).then(({ data }) => data);
  },
  register(data) {
    return HTTP.post(EP.REGISTER, { ...data }).then(({ data }) => data);
  },
  getPendingOrders(data) {
    return HTTP.get(EP.GET_PENDING_ORDERS + "?" + data).then(({ data }) => data);
  },
  getCustomerDetails(customerId) {
    return HTTP.get(EP.GET_CUSTOMER_DETAILS + customerId).then(({ data }) => data);
  },
  paymentAfterCardValidation(orderRefId) {
    return HTTP.get(EP.PAYMENT_AFTER_CARD_VALIDATION + orderRefId).then(({ data }) => data).catch((error) => ( error.response )).catch((error) => ( error.response ));
  },
  multiplePaymentAfterCardValidation(hash) {
    return HTTP.get(EP.MULTIPLE_PAYMENT_AFTER_CARD_VALIDATION + hash).then(({ data }) => data).catch((error) => ( error.response )).catch((error) => ( error.response ));
  },
  paymentCardList(orderRefId) {
    return HTTP.get(EP.PAYMENT_CARD_LIST + orderRefId).then(({ data }) => data).catch((error) => ( error.response )).catch((error) => ( error.response ));
  },
  multiplePaymentCardList(hash) {
    return HTTP.get(EP.MULTIPLE_PAYMENT_CARD_LIST + hash).then(({ data }) => data).catch((error) => ( error.response )).catch((error) => ( error.response ));
  },
  paymentWithSavedCard(data) {
    // return HTTP.get(EP.PAYMENT_WITH_SAVED_CARD + orderRefId).then(({ data }) => data);
    return HTTP.post(EP.PAYMENT_WITH_SAVED_CARD + data.orderRefId, { ...data.data }).then(({ data }) => data).catch((error) => ( error.response ));
  },
  multiplePaymentWithSavedCard(data) {
    return HTTP.post(EP.MULTIPLE_PAYMENT_WITH_SAVED_CARD + data.orderRefId, { ...data.data }).then(({ data }) => data).catch((error) => ( error.response ));
  },
  storeOrder(data) {
    return HTTP.post(EP.STORE_ORDER, { ...data }).then(({ data }) => data);
  },
  updateOrder(data) {
    return HTTP.patch(EP.UPDATE_ORDER + data.entire_order.legacyResourceId, { ...data }).then(({ data }) => data);
  },
  deleteOrder(data) {
    return HTTP.delete(EP.DELETE_ORDER + data.entire_order.legacyResourceId, { ...data }).then(({ data }) => data);
  },
  handleTags(data) {
    return HTTP.post(EP.HANDLE_TAGS, { ...data }).then(({ data }) => data);
  },
  storeMultipleOrders(data) {
    return HTTP.post(EP.ENABLE_MULTIPLE_ORDERS, { ...data }).then(({ data }) => data);
  },
  deleteMultipleOrder(data) {
    return HTTP.post(EP.DELETE_MULTIPLE_ORDERS, { ...data }).then(({ data }) => data);
  },
  getEmailCadenceForOrder(orderRefId) {
    return HTTP.get(EP.GET_EMAIL_CADENCE_FOR_ORDER + orderRefId).then(({ data }) => data);
  },
  resendInvoice(orderLegacyResourceId) {
    return HTTP.post(EP.RESEND_INVOICE + orderLegacyResourceId).then(({ data }) => data);
  },
  resendStatement({ customerId, shopUrl }) {
    return HTTP.get(EP.RESEND_STATEMENT + customerId + "?shop=" + shopUrl).then(({ data }) => data);
  },
  getPlans(data) {
    return HTTP.get(EP.GET_PLANS, { ...data }).then(({ data }) => data);
  },
  subscribeTo(data) {
    return HTTP.post(EP.SUBSCRIBE_PLAN, { ...data }).then(({ data }) => data);
  },
  verifyToken(data) {
    return HTTP.get(EP.VERIFY_TOKEN + data.token).then(({ data }) => data);
  },
  verifySubdomain(data) {
    return HTTP.get(EP.VERIFY_SUBDOMAIN + data.token).then(({ data }) => data);
  },
  resetPassword(data) {
    return HTTP.post(EP.RESET_PASSWORD + data.token, { ...data }).then(({ data }) => data);
  },
  downloadInvoice(orderLegacyResourceId) {
    return HTTP.get(EP.DOWNLOAD_INVOICE + orderLegacyResourceId).then(({ data }) => data);
  },
  downloadCustomerInvoice(data) {
    return HTTP.get(EP.DOWNLOAD_CUSTOMER_INVOICE + data.orderlegacyResourceId + "?shop=" + data.customerShopUrl).then(
      ({ data }) => data
    );
  },
  getRemainingOrdersAllowedToEnableDetails() {
    return HTTP.get(EP.GET_REMAINING_ORDERS_ALLOWED_TO_ENABLE).then(({ data }) => data);
  },
  onboardingVerified() {
    return HTTP.post(EP.ONBOARDING_VERIFIED).then(({ data }) => data);
  },
  checkWebhooks() {
    return HTTP.post(EP.CHECK_WEBHOOKS).then(({ data }) => data);
  },
  checkShopRegistration(data) {
    return HTTP.get(EP.CHECK_SHOP_REGISTRATION, { params: data }).then(({ data }) => data);
  },
  checkStripeConnection(data) {
    return HTTP.get(EP.CHECK_STRIPE_CONNECTION, { params: data }).then(({ data }) => data);
  },
  customerCheckout(data) {
    return HTTP.get(EP.CUSTOMER_CHECKOUT, { params: data }).then(({ data }) => data);
  },
  multipleCustomerCheckout(data) {
    return HTTP.get(EP.MULTIPLE_CUSTOMER_CHECKOUT, { params: data }).then(({ data }) => data);
  },
  markOrderAsPaid(data) {
    return HTTP.post(EP.MARK_ORDER_AS_PAID, { ...data }).then(({ data }) => data);
  },
  markMultipleOrdersAsPaid(data) {
    return HTTP.post(EP.MARK_MULTIPLE_ORDERS_AS_PAID, { ...data }).then(({ data }) => data);
  },
  associateStripeAccount(data) {
    return HTTP.get(EP.ASSOCIATE_STRIPE_ACCOUNT + "?" + data).then(({ data }) => data);
  },
  getAccountDetails() {
    return HTTP.get(EP.GET_ACCOUNT_DETAILS).then(({ data }) => data);
  },
  getAcceptNewScopeAuthUrl() {
    return HTTP.get(EP.GET_ACCEPT_NEW_SCOPE_AUTH_URL).then(({ data }) => data);
  },
  newScopesAccepted(data) {
    return HTTP.get(EP.NEW_SCOPES_ACCEPTED, { params: data }).then(({ data }) => data);
  },
  updateAccountDetails(data) {
    return HTTP.patch(EP.UPDATE_ACCOUNT_DETAILS, { ...data }).then(({ data }) => data);
  },
  enableSendInvoiceOnPendingOrderCreationSetting() {
    return HTTP.post(EP.ENABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING).then(({ data }) => data);
  },
  disableSendInvoiceOnPendingOrderCreationSetting() {
    return HTTP.delete(EP.DISABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING).then(({ data }) => data);
  },
  enableSendStripePaymentLinkInEmail() {
    return HTTP.post(EP.ENABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL).then(({ data }) => data);
  },
  disableSendStripePaymentLinkInEmail() {
    return HTTP.delete(EP.DISABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL).then(({ data }) => data);
  },
  enableSendShopifyCheckoutPaymentLinkInEmail() {
    return HTTP.post(EP.ENABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL).then(({ data }) => data);
  },
  disableSendShopifyCheckoutPaymentLinkInEmail() {
    return HTTP.delete(EP.DISABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL).then(({ data }) => data);
  },
  addCustomNetTerm(data) {
    return HTTP.post(EP.ADD_CUSTOM_NET_TERM, { ...data }).then(({ data }) => data);
  },
  removeCustomNetTerm(data) {
    return HTTP.delete(EP.REMOVE_CUSTOM_NET_TERM + data.id).then(({ data }) => data);
  },
  addEmailInMultipleEmailAddress(data) {
    return HTTP.post(EP.ADD_EMAIL_MULTIPLE_EMAIL_ADDRESS, { ...data }).then(({ data }) => data);
  },
  removeEmailInMultipleEmailAddress(data) {
    return HTTP.delete(EP.REMOVE_EMAIL_MULTIPLE_EMAIL_ADDRESS + data.id).then(({ data }) => data);
  },
  toggleStatusOfEmailInMultipleEmailAddress(data) {
    return HTTP.post(EP.ENABLE_DISABLE_EMAIL_MULTIPLE_EMAIL_ADDRESS + data.id).then(({ data }) => data);
  },
  calculateNetPaymentDaysFromFulfillmentDateSetting() {
    return HTTP.post(EP.CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING).then(({ data }) => data);
  },
  removeCalculateNetPaymentDaysFromFulfillmentDateSetting() {
    return HTTP.delete(EP.REMOVE_CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING).then(({ data }) => data);
  },
  removeLogo() {
    return HTTP.delete(EP.REMOVE_LOGO).then(({ data }) => data);
  },
  getAccountDetailsForCustomerCheckout(data) {
    return HTTP.get(EP.GET_ACCOUNT_DETAILS_FOR_CUSTOMER_CHECKOUT, { params: data }).then(({ data }) => data);
  },
  saveLogo(data) {
    let formData = new FormData();
    formData.append("file", data.file, data.file.name);
    return HTTP.post(EP.SAVE_LOGO, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }).then(({ data }) => data);
  },
  statementForCustomers() {
    return HTTP.post(EP.STATEMENT_FOR_CUSTOMERS).then(({ data }) => data);
  },
  removeStatementForCustomers() {
    return HTTP.delete(EP.REMOVE_STATEMENT_FOR_CUSTOMERS).then(({ data }) => data);
  },
  updateStatementDays(data) {
    return HTTP.put(EP.UPDATE_STATEMENT_DAYS, { ...data }).then(({ data }) => data);
  },
  addPeriodicUpdates() {
    return HTTP.put(EP.ADD_PERIODIC_UPDATES).then(({ data }) => data);
  },
  updateEmail(data) {
    return HTTP.post(EP.SAVE_EMAIL_SETTINGS, { ...data }).then(({ data }) => data);
  },
  getEmailSettings() {
    return HTTP.get(EP.FETCH_EMAIL_SETTINGS, {}).then(({ data }) => data);
  },
  updatePDFEmail(data) {
    return HTTP.post(EP.SAVE_PDF_EMAIL_SETTINGS, { ...data }).then(({ data }) => data);
  },
  getPDFEmailSettings(templateID) {
    return HTTP.get(EP.FETCH_PDF_SETTINGS + "/" + templateID, {}).then(({ data }) => data);
  },
  removePeriodicUpdates() {
    return HTTP.delete(EP.REMOVE_PERIODIC_UPDATES).then(({ data }) => data);
  },
  deleteStripeConnection() {
    return HTTP.delete(EP.DELETE_STRIPE_CONNECTION).then(({ data }) => data);
  },
  getOrderReminderEmailPreview(orderRefId) {
    return HTTP.get(EP.GET_ORDER_REMINDER_EMAIL_PREVIEW + orderRefId).then(({ data }) => data);
  },
  getOrderStatementReminderEmailPreview({ customerRefId, shopUrl }) {
    return HTTP.get(EP.GET_ORDER_STATEMENT_REMINDER_EMAIL_PREVIEW + customerRefId + "?shop=" + shopUrl).then(
      ({ data }) => data
    );
  },
  getBillingAddressesOfCustomer(customerRefId) {
    return HTTP.get(EP.GET_BILLING_ADDRESSES_OF_CUSTOMER + customerRefId).then(({ data }) => data);
  },
  addBillingAddressForCustomer(data) {
    return HTTP.post(EP.ADD_BILLING_ADDRESS_FOR_CUSTOMER, { ...data }).then(({ data }) => data);
  },
  deleteBillingAddressOfCustomer(billingAddress) {
    return HTTP.delete(EP.DELETE_BILLING_ADDRESS_OF_CUSTOMER + billingAddress.id).then(({ data }) => data);
  },
  createRequest(data) {
    return HTTP.post(EP.CUSTOMER_SCREEN_CREATE_REQUEST, { ...data }).then(({ data }) => data);
  },
  getRequestStatus() {
    return HTTP.get(EP.CUSTOMER_SCREEN_REQUEST_STATUS).then(({ data }) => data);
  },
  deactivateRequest() {
    return HTTP.patch(EP.CUSTOMER_SCREEN_DEACTIVATE_REQUEST).then(({ data }) => data);
  },
  getPlansPrices() {
    return HTTP.get(EP.GET_PLANS_PRICES).then(({ data }) => data);
  }
};
